var parallel = require("./node").default;
module.exports = parallel;



//////////////////
// WEBPACK FOOTER
// ./src/api/node-commonjs.js
// module id = 174
// module chunks = 0